import { Component } from '@angular/core';
import { TITLE_SEARCH_MATTER_STATE } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './adjacent-analysis.hooks';

@Component({
	selector: 'app-adjacent-analysis',
	templateUrl: './adjacent-analysis.component.html',
	styleUrls: ['./adjacent-analysis.component.scss'],
	standalone: false,
})
export class TeranetStepperAdjacentAnalysisComponent {
	testHooks = TestHooks;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(private matterDispatch: MatterDispatch) {}

	next = (): void => {
		this.matterDispatch.SetTitleState(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.WRITS,
		);
	};

	back = (): void => {
		this.matterDispatch.SetTitleState(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.INSTRUMENTS,
		);
	};
}
